import DE_FAQ_PAGE_CONSTANTS from './de'
import EN_FAQ_PAGE_CONSTANTS from './en'
import FR_FAQ_PAGE_CONSTANTS from './fr'
import HU_FAQ_PAGE_CONSTANTS from './hu'
import { T_FAQ_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const FAQ_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_FAQ_PAGE_CONSTANTS> = {
  hu: HU_FAQ_PAGE_CONSTANTS,
  en: EN_FAQ_PAGE_CONSTANTS,
  fr: FR_FAQ_PAGE_CONSTANTS,
  de: DE_FAQ_PAGE_CONSTANTS
}

export default FAQ_PAGE_CONSTANTS

export const FAQ_PAGE_CONSTANTS_PATH = objectPathFactory<T_FAQ_PAGE_CONSTANTS>()
